import { getAppInstance } from '/@/store/session/selectors';

export const getLibraryEnabled = (state) => {
    return getAppInstance(state).enableLibrary;
};
